/* eslint-disable */

import apiServer from "../../tools/apiServer";
import sliding from "../../common/js/slidingdoor";

export default {
  /**
   * 
   * @param {String} template vue组件模板
   * @param {htmlElement} el 组件挂在的元素
   * @param {Object} tpl_data 组件数据
   * @param {Array} titleList 组件标题list
   * @param {String} type  组件类型：城市或标签
   */

  createHomeTpl (template, el, tpl_data, titleList, type) {
    createComp();
    function createComp() {
      let comp = Vue.component('my-comp', {
        data () {
          return {
            selectTagName : '',
            iid: window.__iid|| '',
            firstContent: tpl_data,
            titleList: titleList,
            type: type,
            classes: [
              'm_unit_1',
              'm_unit_1 r_m_unit_1',
              'm_unit_2',
              'm_unit_2',
              'm_unit_2',
              'm_unit_slider',
              'm_unit_2',
              'm_unit_2',
              'm_unit_2',
              'm_unit_2'
            ]
          }
        },
        template: template.tplContent,
          mounted() {
            console.log("daibo")
          },
        // template: '<h2>hdfdf</h2>',
        methods: {
          lis_click (e) {

            console.log(e.target);
            let li_name = e.target.dataset.tag_title;
            this.selectTagName= li_name;
            if (this.type == 'city'){
              apiServer.getCityData(li_name).then(data => {
                console.log('li_click byvue')
                this.firstContent = data.t;
              });
            } else if (this.type == 'tag') {
              apiServer.getTagData(li_name).then(data => {
                console.log('li_click byvue')
                this.firstContent = data.t;
              });
            }
            
            //处理颜色
            let sibling = e.currentTarget.parentNode.children;
            for(let j = 0; j < sibling.length; j++){
              if(sibling[j]==e.currentTarget) {
                e.currentTarget.classList && e.currentTarget.classList.add('hover');
              } else {
                sibling[j].classList.remove('hover');
              }
            }  
          },
          list_click (e) {
            window.open(`/list.html?iid=${window.__iid}&tag=${this.selectTagName}`, '_blank');
          },
          toDetail(activityId) {
            window.open(`/detail.html?iid=${window.__iid}&activityId=${activityId}`, '_blank')
          }
        },
      });
      new comp().$mount(el);
    }
  },

  createCommendTpl (detail, el) {
      let direction = -1;
        let comp = Vue.component('recommmend-comp', {
        data () {
          return {
            iid: window.__iid||'',
            tplData: [],
            recommends: detail.tpl_data,
          }
        },
        template: detail.tplContent,
        // template: '<h2>hdfdf</h2>',
        created() {
          this.tplData = this.tplData =  this.recommends.slice(-5);
        },
        methods: {
          changeData () {
            console.log('click change data');
            direction= -1* direction;
            if (direction > 0){
              this.tplData =  this.recommends.slice(0,5);
            } else {
              this.tplData =  this.recommends.slice(-5);
            }
          }
        },
        mounted () {
          sliding("#sliding-door");
        }
      });
      new comp().$mount(el);
  }
}
